import {count, getMentions} from "@/data/Grouse";

export const CONVERSATION_MENTION_LIMIT = 50000;
export const CONVERSATION_STRUCTURE_SELECT = "id,replyToId,reshareCount,published";
export const MENTION_SELECT = "+combinedHtml,phrases,brand,discardedByRule,region,crowdJobs,replyToId,reshareOfId,conversationId,interactionId,platformEngagement,platformReactions,platformComments,platformReshares,platformVideoViews,platformImpressions";
// Author-only MentionItem cards still need the model's standard fields (brand, site, etc.).
export const RESHARE_SELECT = MENTION_SELECT;
export const PUBLIC_FILTER = "visibility is public";
export const RELEVANT_FILTER = "relevancy isnt irrelevant";

// Mention ids are also used to discover the root brand. Never interpolate arbitrary filter text.
export function mentionId(id) {
    if (!/^\d+-\d+$/.test(String(id))) throw new Error("Invalid mention id");
    return String(id);
}

export function getPublicConversationFilter(conversationId) {
    const id = mentionId(conversationId);
    return `brand isorchildof ${id.split('-')[0]} AND conversationId is '${id}' AND ${PUBLIC_FILTER} AND ${RELEVANT_FILTER}`;
}

export function getReshareFilter(parentId) {
    const id = mentionId(parentId);
    return `brand isorchildof ${id.split('-')[0]} AND reshareof is '${id}' AND ${PUBLIC_FILTER} AND ${RELEVANT_FILTER}`;
}

export function listConversationMentions(accountCode, filter, select, limit) {
    return getMentions(filter, ["published asc"], limit, false, false, {accountCode, select});
}

export function getTreeMentions(accountCode, selectedMention) {
    const filter = getPublicConversationFilter(selectedMention.conversationId ?? selectedMention.id);
    return listConversationMentions(accountCode, `${filter} AND reshareof is unknown`, CONVERSATION_STRUCTURE_SELECT, CONVERSATION_MENTION_LIMIT + 1);
}

/** No relevance constraint: irrelevant public ancestors and a public selection provide context. */
export function getMentionsById(accountCode, ids, select = MENTION_SELECT) {
    if (!ids.length) return Promise.resolve([]);
    const filter = `id in (${ids.map(id => `'${mentionId(id)}'`).join(',')}) AND ${PUBLIC_FILTER}`;
    return listConversationMentions(accountCode, filter, select, ids.length);
}

export function getResharePreviews(accountCode, parentId) {
    return listConversationMentions(accountCode, getReshareFilter(parentId), RESHARE_SELECT, 2);
}

export function getReshareTotal(accountCode, parentId) {
    return count(getReshareFilter(parentId), null, ["mentionCount"], null, null, accountCode);
}

